import { useEclipseCycleRecommendation } from '../hooks/useEclipseCycleRecommendation';
export const CycleRecommendationPrefetch = () => {
  useEclipseCycleRecommendation();
  return null;
};
//# sourceMappingURL=CycleRecommendationPrefetch.js.map